module.exports = __webpack_public_path__ + "media/images/hitfun/icon.tg.short-5da0426dbab9cf86a905b058a754c01c.svg";